export default "__VITE_ASSET__f876556c__"